import csc from "country-state-city";
import React, { Component } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap-v5";
import PhoneInput from "react-phone-input-2";
import PickUpServices from "../../../../Services/PickUpService";
import masterServices from "../../../../Services/masterService";
import { vendorService } from "../../../../Services/vendorService";
import CourierPartnerService from "../../../../Services/CourierPartnerService";
import Select from "react-select";
// import * as JobOptions from '../../../Function/defaultJobOptions'

class Schedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pickup: [],
      wareHouseData: [],
      vendorData: [],
      courierPartnerList: [],
      countryData: [
        {
          countryCode: "",
          states: [],
          cities: [],
        },
      ],
      country: csc.getAllCountries(),
    };
  }

  componentDidMount() {
    this.fetchWarehouseData();
    this.fetchVendorData();
    this.courierPartnerList();
  }

  fetchWarehouseData() {
    masterServices
      .get_warehouse()
      .then((result) => {
        if (result.status === true) {
          let wOpt = result.data.map((item) => ({
            value: item._id,
            label: item.name,
          }));
          this.setState({ wareHouseData: wOpt });
        }
      })
      .catch((error) => {
        console.error("Error fetching warehouse data:", error);
      });
  }

  fetchVendorData() {
    this.param = { search1: "Transport" };
    vendorService.getVendor(this.param).then((result) => {
      if (result.status === true) {
        let vOpt = result.data.map((item) => {
          return { value: item._id, label: item.vendor_name };
        });
        this.setState({ vendorData: vOpt });
      }
    });
  }

  setData = () => {
    const { pickup } = this.state;
    if (pickup.length === 0 && this.props.jobData.pickup.length > 0) {
      let data = [];
      for (let i = 0; i < this.props.jobData.pickup.length; i++) {
        if (
          this.props.jobData.pickup[i].pickup_country &&
          this.props.jobData.pickup[i].pickup_state
        ) {
          let findIso = csc
            .getAllCountries()
            .find(
              (item) =>
                item.name === this.props.jobData.pickup[i].pickup_country
            )?.isoCode;
          let allstates = csc.getStatesOfCountry(findIso);
          let findStateIso = allstates.find(
            (item) => item.name === this.props.jobData.pickup[i].pickup_state
          )?.isoCode;
          let allcities = csc.getCitiesOfState(findIso, findStateIso);
          data.push({
            countryCode: findIso,
            states: allstates,
            cities: allcities,
          });
        } else {
          data.push({
            countryCode: "",
            states: [],
            cities: [],
          });
        }
      }
      this.setState({
        pickup: this.props.jobData.pickup,
        countryData: data,
      });
    }
  };

  handleAddClick = () => {
    let letsAdd = [
      ...this.state.pickup,
      {
        type: "pickup",
        pickup_shipment: "",
        salutation: "",
        sender_name: "",
        pickup_contact: "",
        pickup_date: "",
        pickup_time: "",
        address: "",
        email: "",
        delevered_by: "",
        invoice_no: "",
        job_token: this.props.jobToken,
        quote_token: this.props.quoteToken,
      },
    ];
    let isAddCountry = [
      ...this.state.countryData,
      {
        countryCode: "",
        states: [],
        cities: [],
      },
    ];
    this.setState({ pickup: letsAdd, countryData: isAddCountry });
  };

  handleAddDeliveryClick = () => {
    let letsAdd = [
      ...this.state.pickup,
      {
        type: "delivery",
        ware_houses: "",
        pickup_status: "PENDING",
        comment: "",
        job_token: this.props.jobToken,
        quote_token: this.props.quoteToken,
      },
    ];
    let isAddCountry = [
      ...this.state.countryData,
      {
        countryCode: "",
        states: [],
        cities: [],
      },
    ];
    this.setState({ pickup: letsAdd, countryData: isAddCountry });
  };

  handleBackClick = () => {
    this.setState({ pickup: [], countryData: [] });
    this.props.onChangeValue({ value: [] }, "schedule_pickup", "pickup");
  };

  handleRemoveClick = (index) => {
    const list = [...this.state.pickup];
    const listCountry = [...this.state.countryData];
    list.splice(index, 1);
    listCountry.splice(index, 1);
    this.setState(() => {
      return { pickup: list, countryData: listCountry };
    });
  };

  handleInputChage = (event, type, index) => {
    const { name, value } = event.target;
    const list = this.state.pickup;
    list[index][name] = value;
    if (value === "WORLDTODOOR") {
      delete list[index].vendor_id;
    }
    this.setState(() => {
      return { [type]: list };
    });
    this.props.onChangeValue({ value: list }, "schedule_pickup", type);

    if (list[index].type === "delivery" && name === "pickup_status") {
      this.props.onChangeValue({ value: value }, "job_status", "job_status");
      if (value === "DELIVERED") {
        this.props.onChangeValue({ value: "Paid" }, "payment_information", "payment_status");
      }
    }
  };

  onCountryChange = (e, name, key) => {
    let data = this.state.countryData;
    let fieldData = this.state.pickup;
    if (name === "pickup_country") {
      let findIso = this.state.country.find(
        (item) => item.name === e.target.value
      )?.isoCode;
      data[key].states = csc.getStatesOfCountry(findIso);
      data[key].countryCode = findIso;
    } else if (name === "pickup_state") {
      let findIso = this.state.countryData[key].states.find(
        (item) => item.name === e.target.value
      )?.isoCode;
      data[key].cities = csc.getCitiesOfState(data[key].countryCode, findIso);
    }
    fieldData[key][name] = e.target.value;
    this.setState({ pickup: fieldData, countryData: data });
  };

  selectCourierPartner = (e, type, index) => {
    const { name, value } = e.target;
    const list = this.state.pickup;
    list[index][name] = value;
    if (value === "WORLDTODOOR") {
      delete list[index].vendor_id;
    }
    this.setState(() => {
      return { [type]: list };
    });
    this.props.onChangeValue({ value: list }, "schedule_pickup", type);
  };

  courierPartnerList = () => {
    CourierPartnerService.getCourierPartnerList({ status: "ACTIVE" })
      .then((res) => {
        if (res.status) {
          this.setState({ courierPartnerList: res.data });
        } else {
          console.log(res, "err");
        }
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };

  formList = (type, item, index) => {
    const { formValidator } = this.props;
    const { courierPartnerList } = this.state;
    // const { itemData, wareHouseData, vendorData } = this.state
    console.log(item, "item");

    return (
      <Card bg="light" key={`${type}-${index}`}>
        <Card.Body>
          <Card.Title>
            {type.toUpperCase()} - {index + 1}
            {this.state.pickup.length > 1 && (
              <Button
                className="float-end"
                variant="danger"
                size="sm"
                onClick={() => this.handleRemoveClick(index)}
              >
                Remove
              </Button>
            )}
          </Card.Title>
          <Row>
            <Col>
              <div className="row ">
                <div className="position-relative col-3">
                  <label className="form-label">
                    Where to pick your shipment from
                  </label>
                  <div key={`inline-radio`} className="mb-3 d-flex">
                    <Form.Check
                      inline
                      label="Store"
                      name="pickup_address_type"
                      value="store"
                      type="radio"
                      id={`pickup_address_store-${index + 50}`}
                      checked={item.pickup_address_type === "store"}
                      onChange={(e) => this.handleInputChage(e, type, index)}
                    />
                    <Form.Check
                      inline
                      label="Residence"
                      name="pickup_address_type"
                      value="residence"
                      type="radio"
                      id={`pickup_address_residence-${index + 60}`}
                      checked={item.pickup_address_type === "residence"}
                      onChange={(e) => this.handleInputChage(e, type, index)}
                    />
                    <Form.Check
                      inline
                      label="Office"
                      name="pickup_address_type"
                      value="office"
                      type="radio"
                      id={`pickup_address_office-${index + 70}`}
                      checked={item.pickup_address_type === "office"}
                      onChange={(e) => this.handleInputChage(e, type, index)}
                    />
                  </div>
                </div>

                <div className="position-relative d-flex col-md-9">
                  <Form.Group className="mb-3">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      cols={30}
                      value={item.pickup_address}
                      name="pickup_address"
                      onChange={(e) => this.handleInputChage(e, type, index)}
                    />
                  </Form.Group>
                  <div className="row w-100 ps-4">
                    {/* country  */}
                    <div className="mb-3 col-6">
                      <label className="form-label">Country </label>
                      <Form.Select
                        name="pickup_country"
                        value={item.pickup_country}
                        onChange={(e) =>
                          this.onCountryChange(e, "pickup_country", index)
                        }
                      >
                        <option value="">Select Country</option>
                        {this.state.country.map((item1) => {
                          return (
                            <option key={item1.name} value={item1.name}>
                              {item1.name}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </div>
                    {/* state  */}
                    <div className="mb-3 col-6">
                      <label className="form-label">State </label>
                      <Form.Select
                        name="pickup_state"
                        value={item.pickup_state}
                        onChange={(e) =>
                          this.onCountryChange(e, "pickup_state", index)
                        }
                      >
                        <option value="">Select State</option>
                        {this.state.countryData.length > 0 &&
                          this.state.countryData[index]?.states &&
                          this.state.countryData[index].states.map((item1) => {
                            return (
                              <option key={item1.name} value={item1.name}>
                                {item1.name}
                              </option>
                            );
                          })}
                      </Form.Select>
                    </div>
                    {/* city  */}
                    <div className="mb-3 col-6">
                      <label className="form-label">City</label>
                      <Form.Select
                        name="pickup_city"
                        value={item.pickup_city}
                        onChange={(e) =>
                          this.onCountryChange(e, "pickup_city", index)
                        }
                      >
                        <option value="">Select City</option>
                        {this.state.countryData.length > 0 &&
                          this.state.countryData[index]?.cities &&
                          this.state.countryData[index].cities.map((item1) => {
                            return (
                              <option key={item1.name} value={item1.name}>
                                {item1.name}
                              </option>
                            );
                          })}
                      </Form.Select>
                    </div>

                    {/* postal code  */}
                    <div className="mb-3 col-6">
                      <label className="form-label">Postal Code</label>
                      <input
                        type="text"
                        className={"form-control"}
                        name="pickup_postal_code"
                        value={item.pickup_postal_code}
                        onChange={(e) => this.handleInputChage(e, type, index)}
                        placeholder="Enter Postal Code"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <label>
                <span className="d-block  fw-bold">
                  Contact person at your requested pickup location
                </span>
              </label>
              <div className="d-flex">
                <div className="position-relative me-2">
                  <label className="form-label">Salutation</label>
                  <Form.Select
                    name="salutation"
                    value={item.salutation}
                    onChange={(e) => this.handleInputChage(e, type, index)}
                  >
                    <option value="">Select</option>
                    <option value="MR">MR</option>
                    <option value="MRS">MRS</option>
                    <option value="MISS">MISS</option>
                  </Form.Select>

                  {
                    // formValidator.message('salutation', item.salutation, 'required', { className: 'text-danger' })
                  }
                </div>

                <div className="position-relative me-2">
                  <label className="form-label">Full Name</label>
                  <input
                    className="form-control form-control-sm"
                    value={item.full_name}
                    name="full_name"
                    onChange={(e) => this.handleInputChage(e, type, index)}
                  />

                  {
                    // formValidator.message('full_name', item.full_name, 'required', { className: 'text-danger' })
                  }
                </div>

                <div className="position-relative me-2">
                  <label className="form-label">Phone Number</label>
                  {/* <input
                                        className="form-control form-control-sm"
                                        value={item.phone_number}
                                        name="phone_number"
                                        onChange={(e) => this.handleInputChage(e, type, index)}
                                    /> */}

                  <PhoneInput
                    className="telinput"
                    country={"ae"}
                    enableSearch
                    enableAreaCodes={true}
                    value={item.phone_number}
                    onChange={(phone, f, g) =>
                      this.handleInputChage(
                        { target: { name: "phone_number", value: phone } },
                        type,
                        index
                      )
                    }
                  />

                  {
                    // formValidator.message('phone_number', item.phone_number, 'phone', { className: 'text-danger' })
                  }
                </div>

                <div className="position-relative me-2">
                  <label className="form-label">Email</label>
                  <input
                    className="form-control form-control-sm"
                    value={item.email}
                    name="email"
                    onChange={(e) => this.handleInputChage(e, type, index)}
                  />

                  {formValidator.message("email", item.email, "email", {
                    className: "text-danger",
                  })}
                </div>
              </div>
            </Col>
            <Col xs={1}></Col>

            <Col xs={3}>
              <label>
                <span className="d-block fw-bold">
                  Delivery By (Courier Partner )
                </span>
              </label>
              <div className="position-relative me-2">
                <input
                  className="form-control form-control-sm"
                  value={item.courier_partner}
                  name="email"
                  disabled
                />
              </div>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <label>
                <span className="d-block  fw-bold">When to pickup ?</span>
              </label>
              <div className="d-flex">
                <div className="position-relative me-2">
                  <label className="form-label">Pick up date</label>

                  <input
                    type="date"
                    name="pickup_date"
                    className="form-control"
                    value={item.pickup_date}
                    onChange={(e) => this.handleInputChage(e, type, index)}
                  />
                  {
                    // formValidator.message('pickup_date', item.pickup_date, 'required', { className: 'text-danger' })
                  }
                </div>

                <div className="position-relative me-2">
                  <label className="form-label">Time</label>
                  <input
                    type="time"
                    className="form-control"
                    name="pickup_time"
                    value={item.pickup_time}
                    onChange={(e) => this.handleInputChage(e, type, index)}
                  />

                  {
                    // formValidator.message('pickup_time', item.pickup_time, 'required', { className: 'text-danger' })
                  }
                </div>
              </div>
            </Col>

            <Col>
              <label>
                <span className="d-block  fw-bold">What to pickup</span>
              </label>
              <div className="d-flex">
                <div className="position-relative me-2">
                  <Form.Group className="mb-3">
                    <Form.Label>Shipment Description</Form.Label>
                    <Form.Control
                      name="what_to_pickup"
                      value={item.what_to_pickup}
                      onChange={(e) => this.handleInputChage(e, type, index)}
                    />

                    {
                      // formValidator.message('what_to_pickup', item.what_to_pickup, 'required', { className: 'text-danger' })
                    }
                  </Form.Group>
                </div>

                <div className="position-relative me-2">
                  <Form.Group className="mb-3">
                    <Form.Label>Receipt/Invoice Ref#</Form.Label>
                    <Form.Control
                      name="invoice_id"
                      value={item.invoice_id}
                      onChange={(e) => this.handleInputChage(e, type, index)}
                    />
                  </Form.Group>

                  {
                    // formValidator.message('invoice_id', item.invoice_id, 'required', { className: 'text-danger' })
                  }
                </div>
              </div>
            </Col>
          </Row>

          <Row className="mt-3">
            {index === 0 && (
              <Col>
                <div className="position-relative me-2">
                  <label className="form-label">Who will pickup</label>
                  <div key={`inline-radio`} className="mb-3">
                    <Form.Check
                      inline
                      label="World2Door"
                      name="deliverer"
                      value="WORLD2DOOR"
                      type="radio"
                      id={`inline-radio-1`}
                      checked={
                        this.props.totalJobData?.deliverer === "WORLD2DOOR"
                      }
                      onChange={(e) => this.props.onChangeValue(e, "deliverer")}
                    />
                    <Form.Check
                      inline
                      label="Self"
                      name="deliverer"
                      value="SELF"
                      type="radio"
                      id={`inline-radio-2`}
                      checked={this.props.totalJobData?.deliverer === "SELF"}
                      onChange={(e) => this.props.onChangeValue(e, "deliverer")}
                    />
                    <Form.Check
                      inline
                      label="Retailer"
                      name="deliverer"
                      value="RETAILER"
                      type="radio"
                      id={`inline-radio-2`}
                      checked={
                        this.props.totalJobData?.deliverer === "RETAILER"
                      }
                      onChange={(e) => this.props.onChangeValue(e, "deliverer")}
                    />
                  </div>
                </div>
              </Col>
            )}
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Local Delivery Warehouse</Form.Label>
                <Select
                  name="ware_houses"
                  options={this?.state?.wareHouseData}
                  // value={item.ware_houses}

                  value={this.state.wareHouseData?.filter(
                    (obj) => obj?.value === item?.ware_houses
                  )}
                  onChange={(e) => {
                    this.handleInputChage(
                      {
                        target: {
                          name: "ware_houses",
                          value: e.value,
                        },
                      },
                      type,
                      index
                    );
                  }}
                />
              </Form.Group>
            </Col>

            {/* <Col>
                          <div className="position-relative me-2">
                            <label className="form-label">Transporter Name</label>
                            <div key={`inline-radio`} className="mb-3">
                              <Form.Check
                                className="mt-1"
                                inline
                                label="W2D Transport"
                                name="Transportation_option"
                                value="yW2D_Transportes"
                                type="radio"
                                id={`inline-radio-1`}
                                // checked={this.state.insurance_radio === 'yes'}
                                onChange={(e) => this.props.onChangeValue(e, "Transportation_option")}
                              />
                              <Form.Check
                                className="mt-1"
                                inline
                                label="Transport Vendor"
                                name="Transportation_option"
                                value="Transport_Vendor"
                                type="radio"
                                id={`inline-radio-2`}
                                // checked={this.state.insurance_radio === 'no'}
                                onChange={(e) => this.props.onChangeValue(e, "Transportation_option")}
                              />
                            </div>
                          </div>
                        </Col> */}

            {/* <Col>
              <div className="position-relative me-2">
                <label className="form-label">Transport By</label>
                <div key={`inline-radio`} className="mb-3">
                  <Form.Check
                    inline
                    label="W2D Transport"
                    name="transport_by"
                    value="WORLDTODOOR"
                    type="radio"
                    id={`inline-radio-1`}
                    checked={
                      this?.state?.pickup?.[index]?.transport_by === "WORLDTODOOR"
                    }
                    onChange={(e) => {
                      this.handleInputChage(e, type, index);
                    }}
                  />
                  <Form.Check
                    inline
                    label="Transport Vendor"
                    name="transport_by"
                    value="VENDOR"
                    type="radio"
                    id={`inline-radio-2`}
                    checked={this?.state?.pickup?.[index]?.transport_by === "VENDOR"}
                    onChange={(e) => {
                      this.handleInputChage(e, type, index);
                    }}
                  />
                </div>
              </div>
            </Col> */}
            <Col>
              <div className="position-relative me-2">
                <label className="form-label">Transport By</label>
                <div className="mb-3">
                  <Form.Check
                    inline
                    label="W2D Transport"
                    name={`transport_by_${index}`}
                    value="WORLDTODOOR"
                    type="radio"
                    id={`inline-radio-${index}1`}
                    checked={
                      this.state.pickup?.[index]?.transport_by === "WORLDTODOOR"
                        ? true
                        : false
                    }
                    onChange={(e) => {
                      e.target.name = "transport_by";
                      this.handleInputChage(e, type, index);
                    }}
                  />
                  <Form.Check
                    inline
                    label="Transport Vendor"
                    name={`transport_by_${index}`}
                    value="VENDOR"
                    type="radio"
                    id={`inline-radio-${index}2`}
                    checked={
                      this.state.pickup?.[index]?.transport_by === "VENDOR"
                        ? true
                        : false
                    }
                    onChange={(e) => {
                      e.target.name = "transport_by";
                      this.handleInputChage(e, type, index);
                    }}
                  />
                </div>
              </div>
            </Col>

            {this.state.pickup[index].transport_by === "VENDOR" && (
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Transport Vendor Name</Form.Label>
                  <Select
                    name="vendor_id"
                    options={this.state.vendorData}
                    value={this.state.vendorData?.filter(
                      (obj) => obj?.value === item?.vendor_id
                    )}
                    // onChange={(e) => this.handleChangeValue(e, 'vendor_id')}
                    onChange={(e) => {
                      this.handleInputChage(
                        {
                          target: {
                            name: "vendor_id",
                            value: e.value,
                          },
                        },
                        type,
                        index
                      );
                    }}
                  />
                </Form.Group>
              </Col>
            )}
          </Row>

          <Row>
            <Col>
              <Form.Group controlId="formFile" className="mb-3">
                <Form.Label>Document</Form.Label>
                <Form.Control
                  type="file"
                  name="document_file"
                  onChange={(e) => this.handleInputChage(e, type, index)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Retailer Mobile No</Form.Label>
                <Form.Control
                  type="Number"
                  value={item?.retailer_phone_number}
                  name="retailer_phone_number"
                  onChange={(e) => this.handleInputChage(e, type, index)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Pick up status</Form.Label>
                <Form.Select
                  name="pickup_status"
                  value={item.pickup_status}
                  onChange={(e) => this.handleInputChage(e, type, index)}
                >
                  <option value="">Select</option>
                  <option value="PENDING">PENDING</option>
                  <option value="ASSIGNED">ASSIGNED</option>
                  <option value="RECEIVED">RECEIVED</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Comment</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="comment"
                  value={item.comment}
                  onChange={(e) => this.handleInputChage(e, type, index)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  };

  deliveryFormList = (type, item, index) => {
    return (
      <Card bg="light" key={`${type}-${index}`}>
        <Card.Body>
          <Card.Title>
            DELIVERY - {index + 1}
            {this.state.pickup.length > 1 && (
              <Button
                className="float-end"
                variant="danger"
                size="sm"
                onClick={() => this.handleRemoveClick(index)}
              >
                Remove
              </Button>
            )}
          </Card.Title>
          <Row className="mt-3">
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Local Delivery Warehouse</Form.Label>
                <Select
                  name="ware_houses"
                  options={this?.state?.wareHouseData}
                  value={this.state.wareHouseData?.filter(
                    (obj) => obj?.value === item?.ware_houses
                  )}
                  onChange={(e) => {
                    this.handleInputChage(
                      {
                        target: {
                          name: "ware_houses",
                          value: e.value,
                        },
                      },
                      "pickup",
                      index
                    );
                  }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Delivery Status</Form.Label>
                <Form.Select
                  name="pickup_status"
                  value={item.pickup_status || "PENDING"}
                  onChange={(e) => this.handleInputChage(e, "pickup", index)}
                >
                  <option value="">Select</option>
                  <option value="PENDING">PENDING</option>
                  <option value="ASSIGNED">ASSIGNED</option>
                  <option value="DELIVERED">DELIVERED</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Comment</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="comment"
                  value={item.comment || ""}
                  onChange={(e) => this.handleInputChage(e, "pickup", index)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  };

  render() {
    const { pickup } = this.state;
    const { jobData, formValidator, totalJobData } = this.props;
    console.log(jobData, "jobData");
    if (jobData === undefined || jobData.length === 0) return false;
    this.setData();

    return (
      <Card>
        <div className="card-header bg-light d-flex justify-content-between align-items-center">
          <h4 className="mb-0">Schedule</h4>
          {!this.props.isview && pickup.length > 0 && (
            <Button variant="secondary" size="sm" onClick={() => this.handleBackClick()}>
              Back
            </Button>
          )}
        </div>
        <Card.Body>
          <div className="row">
            <div className="mb-3 col-12">
              {pickup.map((item, index) => {
                return item.type === "delivery" ? this.deliveryFormList("delivery", item, index) : this.formList("pickup", item, index);
              })}
            </div>
          </div>

          <div className="row">
            <div className="mb-3 col-md-12 col-12 d-flex gap-2">
              {!this.props.isview && pickup.length === 0 && (
                <>
                  <Button variant="primary" onClick={() => this.handleAddClick()}>
                    Add Pickup
                  </Button>
                  <Button variant="success" onClick={() => this.handleAddDeliveryClick()}>
                    Add Delivery
                  </Button>
                </>
              )}
            </div>
          </div>
        </Card.Body>
      </Card>
    );
  }
}

export default Schedule;
